import AirportRankingTable from "./AirportRankingTable";

export default AirportRankingTable;
